import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

const useGetUserChatToken = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = useCallback(() => {
    const fullUrl = localStorage.getItem('BaseURL') + '/api/user-tokens/usage';

    setLoading(true)
    return new Promise ((resolve, reject) => {
      return axiosInstance.get(fullUrl)
        .then(res => {
          setData(res.data)
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => {
          setLoading(false);
        })
    })
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  return {data, loading, getData};
};

export default useGetUserChatToken
